export default __webpack_public_path__ + "af082524fda0eaa5e99e12ea66de52b6.png";